module.exports = __webpack_public_path__ + "static/media/testimonial7.4b510c9a.png";